import React from "react";

const FAQSection = () => {
  return (
    <section className="w-full bg-white">
      
      {/* FAQ CONTENT */}
      <div className="max-w-6xl mx-auto px-6 py-20">
        <div className="flex items-center justify-between mb-10">
          <h2 className="text-2xl md:text-3xl font-semibold text-[#0F172A]">
            Frequently asked
          </h2>

          <button className="flex items-center gap-2 text-sm text-[#64748B] border border-[#E2E8F0] px-4 py-2 rounded-full hover:bg-[#F8FAFC] transition">
            Still have questions?
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <FAQCard
            question="Will my customers be notified?"
            answer="No. Your customers continue paying you as usual. We stay behind the scenes."
          />
          <FAQCard
            question="Any long-term commitments?"
            answer="No lock-ins. Finance selective invoices whenever you need."
          />
          <FAQCard
            question="What are the fees?"
            answer="A transparent discount rate based on buyer risk and tenor. No hidden charges."
          />
          <FAQCard
            question="How fast can I get funds?"
            answer="Same-day decisions for connected tools and 24–48 hour payouts post-acceptance."
          />
        </div>
      </div>

      {/* CTA BAR */}
      <div className="w-full bg-[#00B3A4]">
        <div className="max-w-6xl mx-auto px-6 py-8 flex flex-col md:flex-row items-center justify-between">
          <p className="text-white text-lg font-semibold mb-4 md:mb-0">
            Ready to move cash locked in invoices?
          </p>

          <button className="text-white font-semibold text-sm underline underline-offset-4 hover:opacity-90 transition">
            Start a Free Assessment
          </button>
        </div>
      </div>

    </section>
  );
};

const FAQCard = ({ question, answer }) => {
  return (
    <div className="border border-[#E2E8F0] rounded-xl p-6 hover:shadow-sm transition">
      <h4 className="text-sm font-semibold text-[#0F172A] mb-2">
        {question}
      </h4>
      <p className="text-sm text-[#64748B] leading-relaxed">
        {answer}
      </p>
    </div>
  );
};

export default FAQSection;
